import React, { useEffect, useState } from 'react';
import { MdArrowBackIos } from 'react-icons/md';
import { useNavigate, useSearchParams } from 'react-router-dom';

import PageBase from '@components/pages/PageBase';
import MonthlyScheduler from '@components/pages/c001/MonthlyScheduler';
import WeeklyScheduler from '@components/pages/c001/WeeklyScheduler';
import { Box, FormControl, FormControlLabel, MenuItem, Select, Switch, Typography } from '@mui/material';

// TODO pagebaseにボタンはいらない
// エリア以降は各ページで持つようにする
const SelectSchedulePage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const searchType = searchParams.get('month') ?? '';
  const title = searchParams.get('title') ?? '';

  useEffect (() => {
    if(searchType === ''){
      searchParams.set('month', 'false')
      setSearchParams(searchParams, {replace: true});
    }
  },[])
  
  const handleBackIconClick = () => {
    navigate(-1);
  };
  const dispTitle = (
    <>
      <MdArrowBackIos style={{ verticalAlign: 'middle' }} onClick={handleBackIconClick} />
      {title}
    </>
  );
  const switchSearchType = (value: string) => {
    if(value === 'true'){
      searchParams.set('month', 'true')
      setSearchParams(searchParams, {replace: true});
    }else{
      searchParams.set('month', 'false')
      setSearchParams(searchParams, {replace: true});
    }   
  }

  const scheduleSelect = (
    <Box display="flex" alignItems="center">
      <FormControl variant="outlined" size='small'>
        <Select
          value={searchType}
          onChange={(event) => switchSearchType(event.target.value)}
          displayEmpty
        >
          <MenuItem value="false">週間</MenuItem>
          <MenuItem value="true">月間</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );

  return (
    <PageBase title={dispTitle} scheduleSelect={scheduleSelect}>
      {searchType === 'false' ? <WeeklyScheduler /> : <MonthlyScheduler />}
    </PageBase>
  );
};

export default SelectSchedulePage;
